import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import ArticleIcon from "@mui/icons-material/Article";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import WarningIcon from "@mui/icons-material/Warning";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { InputAdornment, TextField } from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import { ModalCondicionesOperacion } from "./ModalCondicionesOperacion";
import { ModalAutorizarFacturacionCondicionada } from "./Modales/ModalAutorizarFacturacionCondicionada";
import { ModalComentariosValidarCondiciones } from "./Modales/ModalComentariosValidarCondiciones";

export const ValidarCondicionesOperacionCondicionada = ({
  folio,
  setLoader,
  loader,
  upload
}) => {
  function capitalizar(cadena) {
    return cadena.charAt(0).toUpperCase() + cadena.slice(1).toLowerCase();
  }
  const [openModalCondicion, setOpenModalCondicion] = useState(false);
  const [openModalComentarios, setOpenModalComentarios] = useState(false);
  const [openModalAutorizacion, setOpenModalAutorizacion] = useState(false);
  const [state, setState] = useState({
    header: {},
    detalle: {},
  });

  console.log(state.header.estatus)
  useEffect(() => {
    onCargarState();
  }, []);
  const onCargarState = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACDValidarCondicionesFinanzas/Get?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setState({
          ...state,
          header: result.encabezado,
          detalle: result.detalle,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Crédito Condicionado", JSON.stringify(error), "error");
      });
  };
  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onEnviarComentario = (comentarios, iddocumento) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });

    const post = {
      folio,
      idproceso: 100,
      iddocumento,
      consecutivo: -1,
      comentarios,
      estatus: "M",
    };

    request
      .post(
        "ACTimelineComentariosTask/EnviarComentarioOtorgamientoCondicionado",
        post
      )
      .then((result) => {
        onCargarState();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO CONDICIONADO", JSON.stringify(error), "error");
      });
  };
  const onComentariosModal = (iddocumento) => {
    Swal.fire({
      title: "Agregar comentarios",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onEnviarComentario(result.value, iddocumento);
      }
    });
  };
  const handdleDateTime =
    (iddocumento) =>
      ({ target }) => {
        var array = state.detalle.map((item) => {
          if (item.iddocumento === iddocumento) {
            item.fecha_compromiso = target.value;
          }
          return item;
        });
        setState({
          ...state,
          detalle: array,
        });
      };
  console.log(state.header)
  return (
    <div className="analisis-operacion-condicionada-documentacion">
      {openModalCondicion && (
        <ModalCondicionesOperacion
          setOpenSolicitud={setOpenModalCondicion}
          open={openModalCondicion}
          setLoader={setLoader}
          loader={loader}
          folio={folio}
          iddocumentopedido={25}
          idproceso={150}
        />
      )}
      {openModalAutorizacion && (
        <ModalAutorizarFacturacionCondicionada
          setLoader={setLoader}
          loader={loader}
          folio={folio}
          setOpen={setOpenModalAutorizacion}
          setState={setState}
          state={state}
          upload={upload}
          onCargarState={onCargarState}
        />
      )}
      {openModalComentarios && (
        <ModalComentariosValidarCondiciones
          setOpenSolicitud={setOpenModalComentarios}
          open={openModalComentarios}
          setLoader={setLoader}
          loader={loader}
          folio={folio}
          iddocumentopedido={25}
          idproceso={150}
          titulo={"Comentarios"}
          comentario1={state.header.comentarios_gerente}
          comentario2={state.header.comentarios_finanzas}
        />
      )}
      <div className="analisis-operacion-condicionada-documentacion-header">

        <div className="analisis-operacion-condicionada-documentaicon-header-container">
          {state.header.estatus !== "A" && state.header.habilitar === true && (
            <div
              className="analisis-operacion-condicionada-documentacion-header-modificar"
              onClick={() => setOpenModalCondicion(true)}
            >
              Condiciones de la Operación
            </div>
          )}

          <div className="analisis-operacion-condicionada-documentacion-header-comentarios"
            onClick={() => setOpenModalComentarios(true)}
          >
            comentarios
          </div>
        </div>
        {state.header.estatus !== "A" && state.header.habilitar === true && (
          <div
            className="analisis-operacion-condicionada-documentacion-header-dictamen"
            onClick={() => setOpenModalAutorizacion(true)}
          >
            Autorizar Facturación
          </div>
        )}
      </div>
      <div className="analisis-operacion-jdf-condicionada-documentacion-container scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th></th>
              <th>Documento</th>
              <th>Comentarios</th>
              <th>Fecha Entrega</th>
              <th>Descargar</th>
              <th>Modificar</th>
            </tr>
          </thead>
          <tbody>
            {state.detalle !== undefined &&
              state.detalle !== null &&
              state.detalle.length > 0 &&
              state.detalle.map((item) => (
                <tr>
                  <td
                    className={
                      item.enviar_revision ? "color-green" : "color-yellow"
                    }
                  >
                    <ArticleIcon />
                  </td>
                  <td>{capitalizar(item.documento)}</td>
                  <td>{item.comentarios}</td>
                  <td>
                    {item.habilitar === true &&
                      item.enviar_revision &&
                      item.tiene_documentacion === false && (
                        // <div>{item.fecha_compromiso}</div>
                        <div>
                          <TextField
                            fullWidth
                            size="small"
                            // label="Fecha para completar documentación"
                            variant="outlined"
                            className="fecha"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <TodayIcon fontSize="small" />
                                </InputAdornment>
                              ),
                            }}
                            type="date"
                            value={item.fecha_compromiso}
                            onChange={handdleDateTime(item.iddocumento)} // Asigna el manejador del evento
                          />
                        </div>
                      )}
                  </td>
                  <td>
                    {item.tiene_documentacion === true && (
                      <div onClick={() => onImprimirArchivo(item.iddocumento)}>
                        <CloudDownloadIcon />
                      </div>
                    )}
                  </td>
                  <td>
                    {item.habilitar === true &&
                      (item.enviar_revision === true ? (
                        <div
                          onClick={() => onComentariosModal(item.iddocumento)}
                        >
                          <WarningIcon /> Modificar
                        </div>
                      ) : (
                        <div
                          onClick={() => onComentariosModal(item.iddocumento)}
                        >
                          <WarningIcon /> Solicitar
                        </div>
                      ))}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
